import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule, matSnackBarAnimations } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule, matDialogAnimations } from '@angular/material/dialog';

// import { FileUploadModule } from 'ng2-file-upload';

import { TWAFilterEditorModule } from '../twa-md2-filter-editor/twa-md2-filter-editor.module';

import { MirrorDatePipeModule } from '../../_pipes/mirror-date.pipe';
import { BoloPipeModule } from '../../_pipes/bolo.pipe';
import { MqIfDirectiveModule } from '../../_directives/mqif.directive';

import { TablePartesDialogComponent } from './table-partes-dialog.component';
import { AlertsFormModule } from '../alerts-form.module';
import { FichaAnimalDialogModule } from '../ficha-animal/ficha-animal-dialog.module'

@NgModule({
    imports: [
        CommonModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSelectModule,
        MatChipsModule,
        MatInputModule,
        MatButtonModule,
        MatMenuModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatDialogModule,
        // FileUploadModule,
        TWAFilterEditorModule,
        MirrorDatePipeModule,
        BoloPipeModule,
        MqIfDirectiveModule,
        AlertsFormModule,
        FichaAnimalDialogModule,
        MqIfDirectiveModule
    ],
    declarations: [
        TablePartesDialogComponent,
    ],
    exports: [
        TablePartesDialogComponent,
    ],
    providers: [
    ],
    // entryComponents: [
    //     TablePartesDialogComponent
    // ]
})
export class TablePartesDialogModule {}
